const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';
const OPEN_MODAL = 'OPEN_MODAL';
const CLOSE_MODAL = 'CLOSE_MODAL';
const START_REQUEST = 'START_REQUEST';
const END_REQUEST = 'END_REQUEST';
const CHECK_ACCESS = 'CHECK_ACCESS';
const GET_PARAM = 'GET_PARAM';
const SET_REFERENCE_MODE = 'SET_REFERENCE_MODE';
const SET_GMN_WARNING = 'SET_GMN_WARNING';

// 汎用マスタ
const GET_ALL_GENERAL_PURPOSE_MAP = 'GET_ALL_GENERAL_PURPOSE_MAP';

// 担当者マスタ
const SET_CONTACT_ID = 'SET_CONTACT_ID';

// 初期値
const SET_INIT_VALUES = 'SET_INIT_VALUES';

// ログイン時刻
const SET_LOGIN_TIME = 'SET_LOGIN_TIME';

export default {
  START_REQUEST,
  END_REQUEST,
  OPEN_DIALOG,
  CLOSE_DIALOG,
  OPEN_MODAL,
  CLOSE_MODAL,
  CHECK_ACCESS,
  GET_PARAM,
  GET_ALL_GENERAL_PURPOSE_MAP,
  SET_CONTACT_ID,
  SET_REFERENCE_MODE,
  SET_GMN_WARNING,
  SET_INIT_VALUES,
  SET_LOGIN_TIME,
};
